import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import type {ConnectionEdgeApiInterface} from '@app/shared/interfaces/edgeapi/connectionEdgeAPI'
import type {ConnectionMQTTEdgeApiInterface} from '@app/shared/interfaces/edgeapi/connectionMQTTEdgeApi'

const initialState = {
  connectionName: '',
  connectionDescription: '',
  identifier: '',
  data: null as ConnectionEdgeApiInterface | null,
  mqttData: undefined as ConnectionMQTTEdgeApiInterface | undefined,
  nativeDeviceType: 'Ubuntu',
  nativeData: null as ConnectionEdgeApiInterface | null,
}

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnectionName: (state, action: PayloadAction<string>) => {
      state.connectionName = action.payload
    },
    setConnectionDescription: (state, action: PayloadAction<string>) => {
      state.connectionDescription = action.payload
    },
    setIdentifier: (state, action: PayloadAction<string>) => {
      state.identifier = action.payload
    },
    setData: (state, action: PayloadAction<ConnectionEdgeApiInterface | null>) => {
      state.data = action.payload
    },
    setMqttData: (state, action: PayloadAction<ConnectionMQTTEdgeApiInterface | undefined>) => {
      state.mqttData = action.payload
    },
    setNativeDeviceType: (state, action: PayloadAction<string>) => {
      state.nativeDeviceType = action.payload
    },
    setNativeData: (state, action: PayloadAction<ConnectionEdgeApiInterface | null>) => {
      state.nativeData = action.payload
    },
    resetConnection: () => initialState,
  },
})

export const {
  setConnectionName,
  setConnectionDescription,
  setIdentifier,
  setData,
  setMqttData,
  setNativeDeviceType,
  setNativeData,
  resetConnection,
} = connectionSlice.actions

export default connectionSlice.reducer
